import { useEffect, useState } from "react";
import { IRenter, RENTER_STATUS } from "../../../../types/renter.type";
import { useIndicatorDashboardContext } from "./useIndicatorDashboardContext";
import './IndicatorLeads.css';


type GroupedCancellations = Record<string, IRenter[]>;

const STATUS_LABELS = {
  [RENTER_STATUS.Ativo]: "Ativo",
  [RENTER_STATUS.Incompleto]: "Incompleto",
  [RENTER_STATUS.PendentePagamento]: "Pendente de pagamento",
  [RENTER_STATUS.ProntoParaAprovacao]: "Pronto para aprovação",
  [RENTER_STATUS.ReservaPaga]: "Reserva paga",
  [RENTER_STATUS.ReservaPendentePagamento]: "Reserva pendente de pagamento",
  [RENTER_STATUS.Finished]: "Finalizado",
  [RENTER_STATUS.Recision]: "Recisão",
  [RENTER_STATUS.Recall]: "Recolhimento",
  [RENTER_STATUS.WaitingRescision]: "Aguardando recisão",
  [RENTER_STATUS.Congelado]: "Congelado",
};

function getStatusLabels(status: RENTER_STATUS) {
  return STATUS_LABELS[status] || status;
}

function useGroupedPlanCancellations(plans: IRenter[] = []): GroupedCancellations {
  const [groupedPlans, setGroupedPlans] = useState<GroupedCancellations>({});

  useEffect(() => {
    const grouped: GroupedCancellations = {};

    plans.sort((a, b) => {
      const rawDateA = a?.activationData?.activationDate;
      const rawDateB = b?.activationData?.activationDate;

      const dateA = rawDateA ? new Date(rawDateA) : null;
      const dateB = rawDateB ? new Date(rawDateB) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateB.getTime() - dateA.getTime();
    });


    for (const plan of plans) {
      const rawDate = plan?.activationData?.activationDate;
      const date = rawDate ? new Date(rawDate) : undefined;

      if (!date) continue;

      const key = `${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
      if (!grouped[key]) {
        grouped[key] = [];
      }

      grouped[key].push(plan);
    }

    setGroupedPlans(grouped);
  }, [plans]);

  return groupedPlans;
}

function IndicatorLeads() {
  const { indicator } = useIndicatorDashboardContext();
  const groupedPlans = useGroupedPlanCancellations(indicator?.renters || []);

  return (
    <div className="tabs-border-line">
      <section className="tabs-item-style">
        <h2 className="text-2xl font-semibold my-4">
        {indicator.renters?.length ||0 > 1 ? 'Indicações' : 'Indicação'} ({indicator.renters?.length || 0})
        </h2>

        {Object.entries(groupedPlans).map(([month, renters]) => (
          <details key={month} className="monthly-group border border-gray-300 rounded-md mb-4 bg-white shadow-sm">
            <summary className="cursor-pointer px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-t-md">
              <h3 className="text-lg font-semibold">
                📅 {month} &nbsp;&nbsp;|&nbsp;&nbsp; 👥 {renters.length} {renters.length > 1 ? 'indicações' : 'indicação'}
              </h3>
            </summary>

            <div className="px-4 pt-2 pb-4 grid grid-cols-3 md:grid-cols-3 xl:grid-cols-3 gap-4">
              {renters.map((renter, index) => (
                <div
                  key={index}
                  className="bg-gray-50 p-3 rounded-md border border-gray-200"
                >
                  <p><span className="font-semibold">Cliente:</span> {renter.name}</p>
                  <p><span className="font-semibold">Status:</span> {getStatusLabels(renter.status)}</p>
                  <p><span className="font-semibold">Veículo:</span> {renter.contract?.licensePlate}</p>
                  <p><span className="font-semibold">Data:</span> {renter.contract?.date}</p>
                </div>
              ))}
            </div>
          </details>
        ))}

      </section>
    </div>
  );
}

export default IndicatorLeads;
